var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-warp wh-flex-center"},[_c('div',{staticClass:"header-txt wh-flex-center"},[_c('div',{staticClass:"txt-bg"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_c('div',{staticClass:"title-bottom"}),_c('wh-weather-box',{staticClass:"weather-box"}),_c('wh-date-box',{staticClass:"date-box"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }